import { graphql } from 'react-relay';

export const fundsTableHeaderFragment = graphql`
    fragment FundsTableHeader_header on FundsTable {
        tableheader {
            col
            label
        }
    }
`;
